(function () {
    'use strict';

    run.admin.parts.rackootDropUrl = function() {
        window.addEventListener('dragover', (e) => {
            e = e || event;
            e.preventDefault();
        });

        window.addEventListener('drop', (e) => {
            e = e || event;
            e.preventDefault();
        });
    };
})();
